<base-sidenav
  (onClose)="close()"
  (onClear)="clear()"
  (onValidate)="validate()"
  [showValidate]="true"
  [standardForms]="standardForms"
></base-sidenav>

<ng-template #standardForms>
  <form [formGroup]="getFormGroup('standardForm')">
    <base-form-input
      (autocompleteChange)="autocompleteEstablishment($event)"
      [items$]="getItems$('establishments')"
      (onScroll)="onScrollLine($event, 'establishments')"
      appearance="outline"
      controlName="establishments"
      displayProperty="label"
      label="Établissement"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteMainCity($event)"
      [items$]="getItems$('mainCity')"
      (onScroll)="onScrollLine($event, 'mainCity')"
      appearance="outline"
      controlName="mainCity"
      displayProperty="mainCity"
      label="Ville"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input label="Libellé" [withoutPadding]="true" appearance="outline" controlName="label"></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteDetentionType($event)"
      [items$]="getItems$('detentionType')"
      (onScroll)="onScrollLine($event, 'detentionType')"
      appearance="outline"
      controlName="detentionType"
      displayProperty="label"
      label="Détention"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteSupplier($event)"
      [items$]="getItems$('supplier')"
      (onScroll)="onScrollLine($event, 'supplier')"
      appearance="outline"
      controlName="supplier"
      displayProperty="label"
      label="Bailleur / Propriétaire"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteLeaseType($event)"
      [items$]="getItems$('leaseType')"
      (onScroll)="onScrollLine($event, 'leaseType')"
      appearance="outline"
      controlName="leaseType"
      displayProperty="label"
      label="Type de bail"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>
  </form>
</ng-template>
